import { PencilSimple } from "@phosphor-icons/react";
import { t } from "i18next";

import { EditProfileForm } from "@/components/User";
import type { ModalProps } from "@/shared.types";
import { Circle, Heading, Modal } from "@/ui";

export const EditProfileModal = ({ show, onClose }: ModalProps) => {
  return (
    <Modal
      show={show}
      title={
        <div className="flex flex-col gap-y-2">
          <Heading
            containerClassName="items-center"
            heading={t("profile.edit_profile")}
            left={
              <Circle>
                <PencilSimple size={24} className="text-tertiary-800" />
              </Circle>
            }
          />
          <span className="text-base text-neutral-700">
            *{t("error.required_fields")}
          </span>
        </div>
      }
      onClose={onClose}
    >
      <EditProfileForm onClose={onClose} />
    </Modal>
  );
};
